import { dropdownDarkTheme } from '../molecules/dropdown/dark-theme';
import { bannerLightTheme } from '../organisms/banner/light-theme';
import { bannerDarkTheme } from '../organisms/banner/dark-theme';
import { modalLightTheme } from '../organisms/modal/light-theme';
import { modalDarkTheme } from '../organisms/modal/dark-theme';
import { loaderLightTheme } from '../atoms/loader/light-theme';
import { loaderDarkTheme } from '../atoms/loader/dark-theme';
import { buttonLightTheme } from '../molecules/button/light-theme';
import { buttonDarkTheme } from '../molecules/button/dark-theme';
import { hyperlinkLightTheme } from '../molecules/hyperlink/light-theme';
import { hyperlinkDarkTheme } from '../molecules/hyperlink/dark-theme';
import { inputLightTheme } from '../atoms/input/light-theme';
import { inputDarkTheme } from '../atoms/input/dark-theme';
import { spacingTheme } from '../atoms/spacing/theme';
import { typographyLightTheme } from '../atoms/typography/light-theme';
import { typographyDarkTheme } from '../atoms/typography/dark-theme';
import { colors } from '../atoms/colors/colors';
import { checkboxLightTheme } from '../molecules/checkbox/light-theme';
import { checkboxDarkTheme } from '../molecules/checkbox/dark-theme';
import { dropdownLightTheme } from '../molecules/dropdown/light-theme';
import { cardLightTheme } from '../organisms/card/light-theme';
import { cardDarkTheme } from '../organisms/card/dark-theme';
export const LIGHT_THEME = {
    name: 'light',
    background: colors.white,
    components: {
        atoms: {
            typography: typographyLightTheme,
            spacing: spacingTheme,
            loader: loaderLightTheme,
            input: inputLightTheme,
        },
        molecules: {
            button: buttonLightTheme,
            hyperlink: hyperlinkLightTheme,
            checkbox: checkboxLightTheme,
            dropdown: dropdownLightTheme,
        },
        organisms: {
            modal: modalLightTheme,
            banner: bannerLightTheme,
            card: cardLightTheme,
        },
    },
};
export const DARK_THEME = {
    name: 'dark',
    background: colors.warmgrey800,
    components: {
        atoms: {
            typography: typographyDarkTheme,
            spacing: spacingTheme,
            loader: loaderDarkTheme,
            input: inputDarkTheme,
        },
        molecules: {
            button: buttonDarkTheme,
            hyperlink: hyperlinkDarkTheme,
            checkbox: checkboxDarkTheme,
            dropdown: dropdownDarkTheme,
        },
        organisms: {
            modal: modalDarkTheme,
            banner: bannerDarkTheme,
            card: cardDarkTheme,
        },
    },
};
//# sourceMappingURL=constants.js.map